import CuentaUpdate from './CuentaUpdate'
export {CuentaUpdate}
export default CuentaUpdate
